import React from "react";
import ListProduct from "./ListProduct";
import "./list-items.scss";

const ListItems = ({ customerListDetails, list_id, isCompletedGrid, setProductList }) => {
  function updateProduct(id, qty) {
    const updatedProductList = customerListDetails.map(product => {
      if (product.pp_id === id) {
        return { ...product, qty }
      }
      return product
    })
    setProductList(updatedProductList)
  }

  return (
    <>
      <div className="custom-list-items-table">
        <div className="custom-list-table-header-align">
          <div className="first-title">
            <input type="checkbox" id="termsandconditions" />
            <label htmlFor="termsandconditions">
              <span>Products</span>
            </label>
          </div>
          <div className="child-all-title">
            <div className="child-title">
              <span>Quantity</span>
            </div>
            <div className="child-title">
              <span>Price</span>
            </div>
            <div className="child-title">
              <span>Department</span>
            </div>
            <div className="child-title">
              <span>Remove</span>
            </div>
          </div>
        </div>
        <div className="cart-items-body">
          {customerListDetails?.map(product => {
              return (
                <ListProduct
                  product={product}
                  list_id={list_id}
                  key={product.product_id}
                  isCompletedGrid={isCompletedGrid}
                  updateProduct={updateProduct}
                />
              );
            })}
        </div>
      </div>
    </>
  );
};
export default ListItems;
